import { render } from "./ImageDefaultProductTile.vue?vue&type=template&id=ca908f7e"
const script = {}

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__